import { SET_CUSTOMER_DATA, CLEAR_CUSTOMER_DATA } from "./types";

export const setCustomerData = (data: any) => ({
	type: SET_CUSTOMER_DATA,
	payload: data,
});

export const clearCustomerData = () => ({
	type: CLEAR_CUSTOMER_DATA,
});
